import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6275e7f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "tag is-danger is-rounded has-text-weight-bold ml-1 openTasksIndicator"
};
const _hoisted_2 = {
    key: 0,
    class: "allTaskCount"
};
import { computed } from "vue";
import { TaskStatus, doINeedToActionTask } from "@/core/model";
import { isFeatureEnabled, isNetworkAdmin, sessionState } from "@/core/session";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OpenTasksIndicator',
    props: {
        entityType: {},
        entityId: {}
    },
    setup(__props) {
        const props = __props;
        const countRelevantTasks = (tasks) => {
            // Count the number of tasks which relate to the entity / entity type specified via props
            let count = 0;
            for (let task of tasks) {
                if (task.status == TaskStatus.COMPLETED)
                    continue;
                if (!props.entityType) {
                    ++count;
                    continue;
                }
                if (task.entityType != props.entityType)
                    continue;
                if (!props.entityId) {
                    ++count;
                    continue;
                }
                if (task.entityId == props.entityId) {
                    ++count;
                }
            }
            return count;
        };
        const myTaskCount = computed(() => {
            if (!sessionState.myAssignedTasks)
                return 0;
            return countRelevantTasks(sessionState.myAssignedTasks.filter(t => doINeedToActionTask(t)));
        });
        const allTaskCount = computed(() => {
            if (!sessionState.myAssignedTasks)
                return 0;
            return countRelevantTasks(sessionState.myAssignedTasks);
        });
        return (_ctx, _cache) => {
            return (_unref(isFeatureEnabled)('TASKS') && (myTaskCount.value > 0 || (_unref(isNetworkAdmin)() && allTaskCount.value > 0)))
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createElementVNode("span", null, _toDisplayString(myTaskCount.value), 1),
                    (_unref(isNetworkAdmin)())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "/" + _toDisplayString(allTaskCount.value), 1))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
